export class Session
{
  account_username: string;
  account_type:string;
  account_role:string;
  account_status:string;
  account_balance:string;
  account_userstore:string;
  account_country:string;
  account_currency:string;
}




// WEBPACK FOOTER //
// /tmp/build_713add00/src/models/sessionmodel.ts